<template>
  <div class="tag_container"
    :class="{light: active, disabled: disabled}">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'ITagComponent',
  props: {
    text: {
      type: String,
      default: 'text'
    },
    active: Boolean,
    disabled: Boolean
  },
  data() {
    return {

    };
  },
  components: {

  }
};
</script>

<style scoped lang="stylus">
@import '~@/assets/styles/var.styl';
.tag_container {
  display: inline-block;
  padding: 10px 16px;
  border-radius: 18px;
  background-color: #F8F8FA;
  font-size: $fontSizeNormal;
  color #41414D
  &.light {
    background-color rgba(255, 95, 46, 0.07)
    color #FF5F2E
    font-weight 700
  }
  &.disabled {
    color rgba(65, 65, 77, 0.25)
  }
}
</style>
